import { forgetPush } from "@majitap/ui";
import { useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "@tanstack/react-router";
import { useState } from "react";
import { pushApi } from "./notifications";
import { signOut } from "./session";

/**
 * Signs out and forgets everything cached for the session, from anywhere in the console. Push
 * stops in this browser first, so whoever signs in next doesn't get these alerts.
 */
export function useSignOut() {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const [pending, setPending] = useState(false);
  const run = async () => {
    setPending(true);
    await forgetPush(pushApi);
    try {
      await signOut();
    } catch {
      // the session may already be gone; sign-in is the right place either way
    }
    queryClient.clear();
    await navigate({ to: "/sign-in" });
  };
  return { signOut: run, pending };
}
